import Vue from 'vue';

const state = ({
  cases: [],
  currentCase: null,
  loadedCases: false,
  lastQueryState: null,
  openAttentionCases: 0,
  anyNonOpen: false,

  eligibilityCheckNOV: {},
  markAsPaidPayload: {},
});

const mutations = {
  setOpenAttentionCases(state, count) {
    state.openAttentionCases = count;
  },

  setAnyNonOpen(state, number) {
    state.anyNonOpen = number;
  },

  setLastQueryState(state, query) {
    state.lastQueryState = query;
  },

  setCase(state, theCase) {
    state.currentCase = theCase;

    const index = state.cases.findIndex(c => c.id == theCase.id);
    if (index !== -1) {
      Vue.set(state.cases, index, theCase);
    }
  },

  setCases(state, cases) {
    state.loadedCases = true;
    state.cases = cases;
  },

  setTimeline(state, payload) {
    const index = state.cases.findIndex(c => c.id == payload.id);

    if (index !== -1) {
      if (!state.cases[index].caseTimeline) {
        state.cases[index].caseTimeline = [];
      }
      Vue.set(state.cases[index], 'caseTimeline', [].concat(payload.timeline, state.cases[index].caseTimeline));
      console.log("after", state.cases[index]);
    }
  },

  addTimeline(state, payload) {
    const index = state.cases.findIndex(c => c.id === payload.id);
    if (index !== -1) {
      state.cases[index].caseTimeline.unshift(payload.data);
    }
  },

  updateCase(state, payload) { // TODO: the name of this function is weird.
    const index = state.cases.findIndex(c => c.id === payload.id);
    if (index !== -1) {
      state.cases[index].status = payload.data.status;
      state.cases[index].caseTimeline.unshift(payload.data.timeline);
    }
  },

  setEligibilityCheckNOV(state, payload) {
    // state.eligibilityCheckNOV[payload.eligibilityCheckId] = payload.nov;
    Vue.set(state.eligibilityCheckNOV, payload.eligibilityCheckId, payload.nov);
  },

  setMarkAsPaidPayload(state, payload) {
    state.markAsPaidPayload = payload;
  },
};

const getters = {
  case: (state) => (id) => {
    const theCase = state.cases.find(tc => tc.id === id);
    if (theCase) {
      return theCase;
    }
    return null;
  },

  hasNOV: (state) => (eligibilityCheckId) => {
    return state.eligibilityCheckNOV[eligibilityCheckId];
  },
};

const actions = {
  async searchCases({ rootGetters, commit }, payload) {
    try {
      let endpoint = 'cases/search';
      if (rootGetters['auth/isAdmin']) {
        endpoint = 'admin/cases/search';
      }
      if (payload.status === 'attention') {
        payload.status = 'Open';
        payload.needsResponse = false;
      }
      // Fixing search by column parameter before sending to database.
      if (payload.orderByCol === 'createdOn') {
        payload.orderByCol = 'submittedAt';
      }
      const { data } = await this.$axios.get(endpoint, { params: payload });
      if (data) {
        commit('setCases', data.cases);
        return data;
      }
      commit('setCases', []);
      return [];
    } catch (err) {
      console.log(err);
      commit('setCases', []);
      return [];
    }
  },

  async getCaseTimeline({ rootGetters, commit }, id) {
    try {
      let endpoint = `cases/${id}/timeline`;
      if (rootGetters['auth/isAdmin']) {
        endpoint = `admin/cases/${id}/timeline`;
      }
      const { data } = await this.$axios.get(endpoint);
      if (data.success) {
        commit('setTimeline', { id, timeline: data.timeline });
        return true;
      }
      commit('setTimeline', { id, timeline: []});
      return true;
    } catch (err) {
      commit('setTimeline', { id, timeline: []});
      return false;
    }
  },

  async createTimeline({ rootGetters, commit, dispatch }, payload) {
    try {
      let endpoint = `cases/${payload.id}/timeline`;
      if (rootGetters['auth/isAdmin']) {
        endpoint = `admin/cases/${payload.id}/timeline`;
      }

      const { data } = await this.$axios.post(
        endpoint,
        payload.submitData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (data.success) {
        if (!payload.submitData.has('caseAppealId')) {
          commit('addTimeline', {
            id: payload.id,
            data: data.timeline,
          });
          dispatch('getOpenAttentionCases');
        } else {
          await dispatch('getCase', payload.id);
        }
        return true;
      }
      this.$fatalError();
      return false;
      
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async updateStatus({ rootGetters, commit }, payload) {
    try {
      let endpoint = `cases/${payload.id}/status`;
      if (rootGetters['auth/isAdmin']) {
        endpoint = `admin/cases/${payload.id}/status`;
      }
      
      const { data } = await this.$axios.patch(endpoint, payload.submitData);
      if (data.success) {
        if ([ 'Invalid', 'Valid' ].includes(payload.submitData.status)) {
          data.status = 'Resolved';
        } else if (payload.submitData.status === 'Closed') {
          data.status = 'Closed';
        }
        commit('updateCase', { id: payload.id, data });
        return true;
      } 
      this.$fatalError();
      return false;
      
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async getOpenAttentionCases({ rootGetters, commit }) {
    try {
      
      if (!rootGetters['auth/isAdmin']) {
        let endpoint = `cases/search`;
        const cases = await this.$axios.get(endpoint, { params: { limit: 1 }});
        commit(
          'setAnyNonOpen',
          this.$helpers.findDeepProp('data.cases.length', cases)
        );
      } else {
        commit(
          'setAnyNonOpen',
          true
        );
      }
      const notyNumber = await this.$axios.get('cases/notifications/count');
      commit(
        'setOpenAttentionCases',
        this.$helpers.findDeepProp('data.count', notyNumber)
      );
    } catch (err) {
      console.log("getOpenAttentionCases", err);
      return true;
    }
  },

  // Warning NOV
  async getCase({ commit, dispatch }, id) {
    try {
      const { data } = await this.$axios.get(`cases/${id}`);

      if (data.case) { 
        data.case.aisData = await dispatch(
          'properties/returnAISPropertyDataByOPAAccountNumber',
          data.case.opaAccountNumber,
          { root: true },
        );
        commit('setCase', data.case);
        return data;
      }
      return false;
    } catch (err) {
      console.log(err);
      this.$warning('There was an issue updating the current open case data. Please refresh and try again.');
      return false;
    }
  },

  async submitWarningNOV({ commit }, payload) {
    try {
      const { data } = await this.$axios.post('admin/cases', payload);
      if (data.success) {
        commit('setEligibilityCheckNOV', { eligibilityCheckId: payload.eligibilityCheckId, nov: data });
      }
      return data.success;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async updateWarningNOVs({ dispatch }, payload) { // eslint-disable-line
    try {
      const { data } = await this.$axios.patch(`admin/cases/${payload.caseId}/novs`, { novUpdates: payload.data });
      if (data.success) {
        await dispatch('getCase', payload.caseId);
        return true;
      }
      if (data.message) {
        this.$warning(data.message);
        return false;
      }
      this.$fatalError();
      return false;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },

  async markNOVAsPaid({ state, dispatch }, payload) { // eslint-disable-line
    try {
      let { data }  = await this.$axios.patch(
        `admin/cases/${state.markAsPaidPayload.caseId}/nov/${state.markAsPaidPayload.novId}/paid`,
        payload.submitData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (data.success) {
        await dispatch('getCase', state.markAsPaidPayload.caseId);
        return true;
      }
      this.$warning(data.message);
      return false;
    } catch (err) {
      this.$defaultResponseController(err);
      return false;
    }
  },
  
  async withdrawFee({ dispatch }, payload) {
    try {
      const { data } = await this.$axios.delete(`admin/cases/${payload.caseId}/nov/${payload.novId}/fees/${payload.feeId}`);
      if (data.success) {
        await dispatch('getCase', payload.caseId);
        return true;
      } else if (data.message) {
        this.$warning(`Fine couldn't be withdrawn, is this NOV still open?`);
      }
      return false;
    } catch (err) {
      this.$defaultResponseController(err, true);
      return false;
    }
  },

  async createAppeal({ dispatch }, payload) {
    try {
      const { data } = await this.$axios.post(`cases/${payload.caseId}/appeal`, payload.data);
      if (data.success) {
        await dispatch('getCase', payload.caseId);
        return true;
      }
      return false; 
    } catch (err) {
      this.$defaultResponseController(err, true);
      return false;
    }
  },

  async resolveAppeal(ctx, payload) {
    try {
      const { data } = await this.$axios.patch(
        `admin/cases/${payload.caseId}/appeals/${payload.caseAppealId}`,
        payload.data
      );
      if (data.success) {
        // await dispatch('getCase', payload.caseId);
        return true;
      }
      return false; 
    } catch (err) {
      console.log(err);
      this.$defaultResponseController(err, true);
      return false;
    }
  },
};




export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};